import { Grid } from '@mui/material';
import { useEffect, useRef } from 'react';
import { NumberInputWidget } from 'src/components/widget/numberInputWidget/NumberInputWidget';
import { lang } from 'src/utils';

import { IFrameRangeSelectorProps } from './FrameRangeSelector.interface';
import { FrameRangeSelectorLabel } from './FrameRangeSelector.styled';
import { useFrameRangeValidation } from './FrameRangeValidationContext';

export const FrameRangeSelector = ({
  id,
  label,
  startFrame,
  endFrame,
  onStartFrameChange,
  onEndFrameChange,
}: IFrameRangeSelectorProps) => {
  const { setFrameRangeError } = useFrameRangeValidation();
  const prevHasErrorRef = useRef<boolean | undefined>();

  const handleStartFrameChange = (value: unknown) => {
    onStartFrameChange(value as number);
  };

  const handleEndFrameChange = (value: unknown) => {
    onEndFrameChange(value as number);
  };
  const isEndFrameBeforeStart =
    startFrame !== undefined &&
    endFrame !== undefined &&
    endFrame <= startFrame;
  useEffect(() => {
    if (prevHasErrorRef.current !== isEndFrameBeforeStart) {
      setFrameRangeError(id, isEndFrameBeforeStart);
      prevHasErrorRef.current = isEndFrameBeforeStart;
    }
  }, [id, isEndFrameBeforeStart, setFrameRangeError]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {label && <FrameRangeSelectorLabel>{label}</FrameRangeSelectorLabel>}
      </Grid>
      <Grid item xs={6}>
        <NumberInputWidget
          label={lang.productAnimation.startFrameMsText}
          value={startFrame ?? 0}
          onChange={handleStartFrameChange}
          options={{ min: 0, max: endFrame ? endFrame - 1 : undefined }}
        />
      </Grid>
      <Grid item xs={6}>
        <NumberInputWidget
          label={lang.productAnimation.endFrameMsText}
          value={endFrame}
          onChange={handleEndFrameChange}
          options={{ min: startFrame ? startFrame + 1 : 0 }}
          hasError={isEndFrameBeforeStart}
          error={isEndFrameBeforeStart ? lang.validationError : false}
        />
      </Grid>
    </Grid>
  );
};
